export default __webpack_public_path__ + "static/media/support.f36fea7c.svg";